import { IBatch } from '../@types/API/IBatches'
import axios from './axios'


const getBatchesByFarm = (
    farmId: number,
    request?: { signal?: AbortSignal },
): Promise<IBatch[]> => {
    return axios.get<IBatch[]>(`/batches`, {
        params: { farm_id: farmId },
        signal: request?.signal,
    }).then(({ data }) => {
        return data
    })
}

export const batchService = {
    getBatchesByFarm
}